<template>
  <div class="justify-center text-center py-7 mx-auto white rounded-lg" style="width: 90vw">
    <v-img
          :src="require('../assets/støttelogo.png')"
          class="my-3"
          contain
          height="200"
    />
<NytMedlem/>
  </div>
</template>

<script>
// @ is an alias to /src
import NytMedlem from '@/components/NytMedlem.vue'

export default {
  name: 'Nyt-Medlem',
  components: {
    NytMedlem
  }
}
</script>
